import { render, staticRenderFns } from "./TermsAndConditionsWrapper.vue?vue&type=template&id=c833a838&scoped=true"
import script from "./TermsAndConditionsWrapper.vue?vue&type=script&lang=ts"
export * from "./TermsAndConditionsWrapper.vue?vue&type=script&lang=ts"
import style0 from "./TermsAndConditionsWrapper.vue?vue&type=style&index=0&id=c833a838&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c833a838",
  null
  
)

export default component.exports